export const CANDIDATE_REJECTION_REASONS = [
  "SkillsMismatch",
  "InsufficientExperience",
  "UnavailableAtRequestedTime",
  "SalaryExpectation",
  "BetterCandidateFound",
  "OtherReason",
] as const;

export type CandidateRejectionReason =
  (typeof CANDIDATE_REJECTION_REASONS)[number];

export type CandidateRejectionDetails = {
  rejectionReason?: CandidateRejectionReason | null;
  rejectionComment?: string | null;
};
